import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify'; // <-- import toast
import 'react-toastify/dist/ReactToastify.css';
import DashboardStats from './Dashboard/DashboardStats';
import DashboardLayout from './DashboardLayout';
import FundraisingChart from './Dashboard/FundraisingChart';
import PageLoader from '../../../Reusable/PageLoader';
import baseURL from '../../user/config';

const Dashboard = () => {
    const [data, setData] = useState({ stats: null, fundraising: [] });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAllDashboardData = async () => {
            try {
                // Delay for 4 seconds before fetching
                // await new Promise(resolve => setTimeout(resolve, 4000));

                const [statsResponse, fundraisingResponse] = await Promise.all([
                    fetch(`${baseURL}/org/dashboard-stats`, { credentials: 'include' }),
                    fetch(`${baseURL}/org/fundraising-data`, { credentials: 'include' })
                ]);

                if (!statsResponse.ok || !fundraisingResponse.ok) {
                    throw new Error("Failed to fetch dashboard data.");
                }

                const [statsData, fundraisingData] = await Promise.all([
                    statsResponse.json(),
                    fundraisingResponse.json()
                ]);

                setData({ stats: statsData, fundraising: fundraisingData });
            } catch (err) {
                toast.error(`Error fetching dashboard data: ${err.message}`); // <-- show toast
            } finally {
                setLoading(false);
            }
        };

        fetchAllDashboardData();
    }, []);

    return (
        <DashboardLayout>
            {loading && <PageLoader />} {/* <-- loader inside layout */}
            
            {!loading && (
                <>
                    <DashboardStats stats={data.stats} />
                    <FundraisingChart fundraisingData={data.fundraising} />
                    {/* ... other components */}
                </>
            )}
        </DashboardLayout>
    );
};

export default Dashboard;
